/* Reusable MILTROO tracking service — Meta Pixel (browser) + server event mirror with
   shared event_id for dedup, UTM persistence, GA4-ready. Never blocks UX; failures are
   swallowed so tracking can never break checkout/orders. */
import { API } from "./api";

const CAPI_NAME = { page_view: "PageView", view_item: "ViewContent", search: "Search",
  add_to_cart: "AddToCart", begin_checkout: "InitiateCheckout", purchase: "Purchase",
  generate_lead: "Lead", sign_up: "CompleteRegistration" };
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const loadedPixels = new Set();

export function initPixel(pixelId) {
  if (!pixelId || loadedPixels.has(pixelId) || typeof window === "undefined") return;
  loadedPixels.add(pixelId);
  const f = window, b = document;
  if (f.fbq) return;
  const n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
  if (!f._fbq) f._fbq = n;
  n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
  const t = b.createElement("script"); t.async = true;
  t.src = "https://connect.facebook.net/en_US/fbevents.js";
  const s = b.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(t, s);
  window.fbq("init", pixelId);
}

export function initGa4(measurementId) {
  if (!measurementId || typeof window === "undefined" || document.querySelector(`script[data-mz-ga4="${measurementId}"]`)) return;
  const s = document.createElement("script");
  s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  s.setAttribute("data-mz-ga4", measurementId);
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", measurementId);
}

export function captureUtm() {
  if (typeof window === "undefined") return;
  try {
    const q = new URLSearchParams(window.location.search);
    const cur = JSON.parse(sessionStorage.getItem("mz_utm") || "{}");
    let changed = false;
    for (const k of UTM_KEYS) {
      if (q.get(k)) { cur[k] = q.get(k); changed = true; }
    }
    if (!cur.landing_page) { cur.landing_page = window.location.pathname; changed = true; }
    if (changed) sessionStorage.setItem("mz_utm", JSON.stringify(cur));
  } catch { /* ignore */ }
}

export const getUtm = () => {
  try { return JSON.parse(sessionStorage.getItem("mz_utm") || "{}"); } catch { return {}; }
};

const newEventId = () =>
  (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

/* Track one event: browser Pixel (if initialized for this context) + server mirror
   (drives the funnel analytics; server forwards platform events to Meta CAPI with the
   SAME event_id for deduplication). */
export function track(event, data = {}, { scope = "platform", slug = "" } = {}) {
  const eventId = newEventId();
  try {
    if (window.fbq && CAPI_NAME[event]) window.fbq("track", CAPI_NAME[event], data, { eventID: eventId });
    if (window.gtag) window.gtag("event", event, data);
  } catch { /* never break UX */ }
  try {
    fetch(`${API}/public/track`, {
      method: "POST", headers: { "Content-Type": "application/json" }, keepalive: true,
      body: JSON.stringify({
        event, event_id: eventId, scope, store_slug: slug,
        page: window.location.pathname + window.location.search,
        url: window.location.href,
        value: data.value || 0, currency: data.currency || "INR",
        utm: getUtm(), items: data.items || [],
      }),
    }).catch(() => {});
  } catch { /* ignore */ }
  return eventId;
}
